/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Produced from packages/ui/tokens.json and tokens.elevation.json by
 * packages/ui/scripts/build-tokens.mjs. Change the JSON, then run:
 *
 *     npm run tokens:build
 */
/** Fluent BrandVariants ramp. Rungs 60/70/80 drive light, 90/100/110 drive dark. */
export const brandRamp = {
    '10': '#04150e',
    '20': '#0a2419',
    '30': '#0e3626',
    '40': '#114733',
    '50': '#155941',
    '60': '#186b4f',
    '70': '#1e7a5a',
    '80': '#2a8c69',
    '90': '#3d9c7a',
    '100': '#55ac8c',
    '110': '#6fbb9e',
    '120': '#8bc9b1',
    '130': '#a8d7c4',
    '140': '#c4e4d7',
    '150': '#ddf0e8',
    '160': '#f0f9f5',
};
/** Compliance state colours, keyed by colour scheme (PLAN §8). */
export const complianceColors = {
    light: {
        good: '#1e7a5a',
        warning: '#a16207',
        critical: '#b0392f',
        attention: '#41599c',
    },
    dark: {
        good: '#55be8e',
        warning: '#d9a441',
        critical: '#e07a6e',
        attention: '#8fa8e2',
    },
};
/** Page tints behind a compliance state (#257). Light theme only; `good` equals brandRamp 160. */
export const statusTints = {
    good: '#f0f9f5',
    warning: '#fdf6e7',
    critical: '#fbeeed',
    attention: '#eef1f8',
};
export const spacing = {
    xxs: '2px',
    xs: '4px',
    sNudge: '6px',
    s: '8px',
    mNudge: '10px',
    m: '12px',
    l: '16px',
    xl: '20px',
    xxl: '24px',
    xxxl: '32px',
};
/** Fixed control geometry from the 06b frames: the icon box and the standard control height. */
export const size = {
    icon: '20px',
    control: '40px',
};
export const radius = {
    small: '4px',
    medium: '10px',
    large: '12px',
    xLarge: '16px',
};
export const fontSize = {
    base100: '10px',
    base200: '12px',
    base300: '14px',
    base400: '16px',
    base500: '20px',
    base600: '24px',
    hero700: '28px',
    hero800: '32px',
    hero900: '40px',
    hero1000: '68px',
};
export const lineHeight = {
    base100: '14px',
    base200: '16px',
    base300: '20px',
    base400: '22px',
    base500: '28px',
    base600: '32px',
    hero700: '36px',
    hero800: '40px',
    hero900: '52px',
    hero1000: '92px',
};
export const fontWeight = {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
export const fontFamily = {
    base: "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
    monospace: "Consolas, 'Courier New', Courier, monospace",
    numeric: "Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
};
export const elevation = {
    shadow2: '0 0 2px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.14)',
    shadow4: '0 0 2px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.14)',
    shadow8: '0 0 2px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.14)',
    shadow16: '0 0 2px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.14)',
    shadow28: '0 0 8px rgba(0,0,0,0.12), 0 14px 28px rgba(0,0,0,0.14)',
    shadow64: '0 0 8px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.14)',
    shadowCard: '0 4px 8px rgba(14,77,65,0.10)',
};
//# sourceMappingURL=tokens.generated.js.map